import React, { useEffect, useState } from "react";
// ---- Style ---- //
import "./index.scss";
import { FaRegTrashAlt } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchProducts,
  createProduct,
  updateProduct,
  deleteProduct,
} from "../../store/features/productSlice";
import { fetchCategories } from "../../store/features/categorySlice";
import imageCompression from "browser-image-compression";
import IMG from "./akcia.png";

const MAX_SIZE_MB = 1;
// ---- Components ---- //

const Products = () => {
  const { products } = useSelector((state) => state.product);
  const { categories } = useSelector((state) => state.category);
  const [modalIsActive, setModalIsActive] = useState(false);
  const [editProduct, setEditProduct] = useState(null);
  const [formData, setFormData] = useState({
    name: "asd",
    category: "1",
    price: "123",
    description: "asd",
    minAmount: "1",
    images: [],
    promotion: false,
    promotionDescription: "",
    isActive: true,
  });
  const [searchTerm, setSearchTerm] = useState("");

  const filteredProducts = products.filter((product) =>
    product.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchProducts());
    dispatch(fetchCategories());
  }, [dispatch]);

  const handleDelete = async (productId) => {
    const confirmed = window.confirm(
      "Вы уверены, что хотите удалить этот продукт?"
    );

    if (!confirmed) {
      return;
    }

    try {
      await dispatch(deleteProduct(productId)).unwrap();
      alert("Продукт успешно удалён");
    } catch (error) {
      alert("Произошла ошибка при удалении товара");
    }
  };

  const modalHandler = () => {
    const isFormEmpty = Object.values(formData).every((value) => value === "");

    if (!isFormEmpty) {
      const isConfirmed = window.confirm(
        "Все данные будут потеряны. Вы уверены, что хотите закрыть форму?"
      );
      if (!isConfirmed) return;
    }

    setModalIsActive(!modalIsActive);
    if (modalIsActive) {
      resetFormData();
      setEditProduct(null);
    }
  };

  const resetFormData = () => {
    setFormData({
      name: "",
      category: "",
      price: "",
      description: "",
      minAmount: "",
      images: [],
      promotion: false,
      promotionDescription: "",
      isActive: true,
    });
  };

  const handleChange = async (e) => {
    const { name, type, files } = e.target;

    if (type === "file") {
      const newImages = Array.from(files);
      if (formData.images.length + newImages.length > 5) {
        alert("Вы можете загрузить не более 5 изображений.");
        return;
      }

      const readerPromises = newImages.map(async (image) => {
        const imageSizeMB = image.size / (1024 * 1024); // Размер в MB

        // ❗ Запрет на загрузку изображений больше 1MB
        if (imageSizeMB > MAX_SIZE_MB) {
          alert(
            `Изображение "${image.name}" превышает допустимый размер в ${MAX_SIZE_MB}MB и не будет загружено.`
          );
          return null;
        }

        try {
          // (Дополнительно можно всё равно сжать даже маленькие картинки)
          const options = {
            maxSizeMB: MAX_SIZE_MB,
            maxWidthOrHeight: 1024,
            useWebWorker: true,
          };

          const compressedImage = await imageCompression(image, options);
          return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => {
              resolve(reader.result); // base64
            };
            reader.onerror = reject;
            reader.readAsDataURL(compressedImage);
          });
        } catch (error) {
          console.error("Ошибка при обработке изображения:", error);
          return null;
        }
      });

      Promise.all(readerPromises)
        .then((base64Images) => {
          const validImages = base64Images.filter((img) => img !== null);

          setFormData((prevData) => ({
            ...prevData,
            images: [...prevData.images, ...validImages],
          }));
        })
        .catch((error) => {
          console.error("Ошибка при чтении файлов:", error);
        });
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: e.target.value,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name || !formData.price || formData.images.length === 0) {
      alert("Заполните все обязательные поля!");
      return;
    }

    const productData = {
      ...formData,
      images: formData.images,
    };

    if (editProduct) {
      await dispatch(updateProduct({ id: editProduct.id, data: productData }));
    } else {
      await dispatch(createProduct(productData));
    }

    dispatch(fetchProducts());
    setModalIsActive(false);
    resetFormData();
    setEditProduct(null);
  };

  const handleImageRemove = (index) => {
    const updatedImages = formData.images.filter((_, i) => i !== index);
    setFormData((prevData) => ({ ...prevData, images: updatedImages }));
  };

  useEffect(() => {
    if (modalIsActive) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [modalIsActive]);

  return (
    <div className="products">
      <div className="products__header">
        <div className="header__sales">
          <p className="header_p">
            Количество товара:{" "}
            <span className="header__amount">{products.length} </span>
          </p>
        </div>

        <input
          type="text"
          className="products__search"
          placeholder="Поиск по названию..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <button
          className="products__btn btn"
          onClick={() => setModalIsActive(true)}
        >
          Добавить +
        </button>
      </div>

      <div className="products__content">
        <h2 className="products__title">Ваши товары</h2>
        <div className="products__list">
          {filteredProducts.map((product) => (
            <div
              key={product.id}
              className={`product ${!product.isActive ? "notActive" : ""}`}
            >
              <span
                className="product__delete"
                onClick={() => handleDelete(product.id)}
              >
                <FaRegTrashAlt className="product__icon" />
              </span>

              {product.promotion && (
                <div className="product__promotion">
                  <img src={IMG} alt="promotionImg" />
                </div>
              )}
              <div className="product__img">
                <img src={product.images[0]} alt="product-images" />
              </div>
              <h3 className="product__title">{product.name}</h3>
              <p className="product__price">{product.price} сом</p>
              <button
                className="product__btn"
                onClick={() => {
                  setFormData({
                    ...product,
                    category: "" + product.category.id,
                  });
                  setEditProduct(product);
                  setModalIsActive(true);
                }}
              >
                Подробнее
              </button>
            </div>
          ))}
        </div>
      </div>

      {modalIsActive && (
        <div className="modal-overlay" onClick={modalHandler}>
          <form
            className="create-product-modal"
            onClick={(e) => e.stopPropagation()}
            onSubmit={handleSubmit}
          >
            <span className="close" onClick={modalHandler}></span>

            <h3 className="create-product-modal__title">
              {editProduct ? "Редактировать товар" : "Создать продукт"}
            </h3>

            <label className="create-product-modal__label">
              Название
              <input
                className="create-product-modal__input"
                type="text"
                name="name"
                placeholder="Хлеб"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </label>

            <label className="create-product-modal__label">
              Категория
              <select
                className="create-product-modal__input"
                name="category"
                value={formData.category}
                onChange={handleChange}
                required
              >
                <option value="">Выберите категорию</option>
                {categories && categories.length > 0 ? (
                  categories.map((category) => (
                    <option key={category.id} value={category.id}>
                      {category.name}
                    </option>
                  ))
                ) : (
                  <option disabled>Нет категорий</option>
                )}
              </select>
            </label>

            <label className="create-product-modal__label">
              Цена (СОМ)
              <input
                className="create-product-modal__input"
                type="number"
                name="price"
                placeholder="20"
                value={formData.price}
                onChange={handleChange}
                required
              />
            </label>

            <label className="create-product-modal__label">
              Описание
              <textarea
                className="create-product-modal__textarea"
                name="description"
                placeholder="Свежий белый хлеб, выпеченный по традиционной рецептуре."
                value={formData.description}
                onChange={handleChange}
                required
              />
            </label>

            <label className="create-product-modal__label">
              Фото товара
              <input
                className="create-product-modal__input"
                type="file"
                name="images"
                accept="image/*"
                multiple
                onChange={handleChange}
                required={formData.images.length === 0}
              />
              <small>{formData.images.length} из 5 изображений выбрано</small>
            </label>

            <div className="create-product-modal__image-preview">
              {formData.images.map((image, index) => (
                <div key={index} className="preview-item">
                  <div className="preview-img-block">
                    <img
                      src={image}
                      alt={`preview-${index}`}
                      className="preview-img"
                    />
                  </div>
                  <button
                    type="button"
                    className="remove-img-btn"
                    onClick={() => handleImageRemove(index)}
                  >
                    Удалить
                  </button>
                </div>
              ))}
            </div>

            <label className="create-product-modal__label">
              Минимальное количество для продажи
              <input
                className="create-product-modal__input"
                type="number"
                name="minAmount"
                placeholder="10"
                value={formData.minAmount}
                onChange={handleChange}
                required
              />
            </label>

            <label className="toggle-switch">
              <input
                type="checkbox"
                checked={formData.isActive}
                onChange={(e) =>
                  setFormData({ ...formData, isActive: e.target.checked })
                }
              />
              <span className="slider"></span>
              <span className="label-text">
                {formData.isActive ? "Активен" : "Неактивен"}
              </span>
            </label>

            <label className="toggle-switch">
              <input
                type="checkbox"
                checked={formData.promotion}
                onChange={(e) =>
                  setFormData({ ...formData, promotion: e.target.checked })
                }
              />
              <span className="slider"></span>
              <span className="label-text">
                Добавить акцию для данного товара
              </span>
            </label>

            {formData.promotion && (
              <label className="create-product-modal__label">
                Описание акции
                <textarea
                  className="create-product-modal__textarea"
                  name="promotionDescription"
                  placeholder="Например: При покупке 20 штук — 2 хлеба в подарок"
                  value={formData.promotionDescription}
                  onChange={handleChange}
                  required
                />
              </label>
            )}

            <button className="create-product-modal__button" type="submit">
              {editProduct ? "Сохранить изменения" : "Добавить"}
            </button>

            <button
              className="create-product-modal__cancelBtn"
              onClick={modalHandler}
            >
              Отменить
            </button>
          </form>
        </div>
      )}
    </div>
  );
};

export default Products;
